module.exports = __webpack_public_path__ + "static/media/history-7.8211fb30.jpg";